import './Checkout.css';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import React, { useContext } from 'react';
import Basket from './Basket';
import { CheckoutContext, Environments } from '../../store/CheckoutContext';

interface Props {
  children: React.ReactChild;
  handleCheckout: (environment: Environments) => Promise<void>;
}

const CheckoutTemplate: React.FC<Props> = props => {
  const { children, handleCheckout } = props;
  const { environment, loading, paymentErrors, setPaymentErrors } = useContext(CheckoutContext);

  return (
    <div className="Checkout">
      {loading && (
        <div className="fullscreen-loader">
          <div className="loader" />
          <div className="loader-text">Gateway processing payment</div>
        </div>
      )}
      <div className="checkout-grid">
        <div className="checkout-payment-container">{children}</div>
        <Basket />
      </div>
      <div className="buttons">
        <Button variant="outlined" onClick={() => handleCheckout(environment)} id="submit" disabled={loading}>
          {/*{loading ? <div className="loader" /> : 'Submit'}*/}
          Checkout
        </Button>
        <Dialog
          open={paymentErrors !== null}
          onClose={() => setPaymentErrors(null)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'Debug internal'}</DialogTitle>
          <DialogContent>
            <div className="error-description">Merchant will not see this error</div>
            <div>
              <b>Code</b> - {paymentErrors?.code || ''}
            </div>
            <div>
              <b>Message</b> - {paymentErrors?.message || ''}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPaymentErrors(null)}>OK</Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default CheckoutTemplate;
